import React, {useContext, useEffect, useState} from 'react';
import VideoPlayer from '../components/Player';
import {Container, Box, Grid} from '@material-ui/core';
import {makeStyles} from "@material-ui/core/styles";
import PlayerInfo from '../components/Player/PlayerInfo';
import SessionDetail from '../components/SessionDetails';
import {useHistory, useLocation} from "react-router-dom";
import SpringModal from '../components/Modal';
import {JsonContext} from "../../Context";
import {getSessionState} from "../../utils/date";
import {fetchStreamJson} from "../../utils/api";
import {apiTimeInterval, BUTTON_STATE} from "../../constant";
import {checkAuth} from "../../utils/sessionAuth";

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    watchMainWrapper: {
        backgroundColor: '#000',
        fontFamily: 'Manrope'
    },
    playerContainer: {
        padding: '24px 0 25px',
        justifyContent: 'center',
        display: 'flex',
        [theme.breakpoints.down('xs')]: {
            maxwidth: '100%',
            padding: '24px 15px 25px'
        },

    },
    watchDetailWrapper: {
        backgroundColor: '#111',
        padding: '32px 0',
        [theme.breakpoints.down('xs')]: {
            padding: '24px 0',
        },
    },
    playerDetails: {
        paddingBottom: '24px'
    },
    player: {
        [theme.breakpoints.down('sm')]: {
            marginRight: '0',
            marginBottom: '15px'
        },
    }
}));

function Watch(props) {
    const classes = useStyles();
    let history = useHistory();
    const {location, match: {params: {id}}} = props;
    const [sessionData, setSessionData] = useState({})
    const scheduleData = useContext(JsonContext).schedule;
    const data = useContext(JsonContext).watch;
    const [videoObj, setVideoObj] = useState({
        stream: null,
        type: null,
        data: {}
    });
    let streamInterval = null;
    const getSessionData = () => {
        let session = null;
        for (let i = 0; i < scheduleData.list.length; i++) {
            for (let j = 0; j < scheduleData.list[i].sessions.length; j++) {
                if (scheduleData.list[i].sessions[j].id == id) {
                    session = scheduleData.list[i].sessions[j];
                    setSessionData(session)
                    break;
                }
            }
        }
        let state = getSessionState(session);
        console.log('state-------------------', state)
        switch (state){
            case BUTTON_STATE.LIVE:
                if (checkAuth(session.id)) {
                    fetchStreamJson(session.stream).then(result => {
                        setVideoObj({
                            stream: session.stream,
                            type: result.defaultVideo,
                            data: result.videos.find(vid => vid.id == result.defaultVideo)
                        })
                    })
                } else {
                    history.push({
                        pathname: `/schedule`,
                    })
                }
                break;
            case BUTTON_STATE.VOD:
                if (checkAuth(session.id)) {
                    setVideoObj({
                        stream: null,
                        type: BUTTON_STATE.VOD,
                        data: {
                            videoUrl: session.vodUrl,
                        }
                    })
                } else {
                    history.push({
                        pathname: `/schedule`,
                    })
                }
                break;
            case BUTTON_STATE.ENDED:
                if (!(checkAuth(session.id) && videoObj.type)){
                    history.push({
                        pathname: `/schedule`,
                    })
                }
                break;
            case BUTTON_STATE.UNPUBLISHED:
                history.push({
                    pathname: `/schedule`,
                })
                break;
        }
    }
    useEffect(async () => {
        window.scrollTo({top: 0});
        document.title = data.title;
    }, [])

    useEffect(async () => {
        getSessionData();
    }, [scheduleData])

    useEffect(()=>{
        streamInterval = setInterval(async ()=>{
            videoObj.stream && await fetchStreamJson(videoObj.stream).then(result=>{
                if(videoObj.data.videoUrl !== result.videos.find(vid => vid.id == result.defaultVideo).videoUrl){
                    setVideoObj({
                        stream: videoObj.stream,
                        type: result.defaultVideo,
                        data: result.videos.find(vid => vid.id == result.defaultVideo)
                    })
                }
            })
        }, apiTimeInterval *1000);
        return ()=>{
            clearInterval(streamInterval)
        }
    },[videoObj])

    return (
        <div className={classes.watchMainWrapper}>
            {videoObj.data && videoObj.data.videoUrl && <Container maxWidth={'lg'}>
                <Grid container maxWidth='lg' className={classes.playerContainer} spacing={3}>
                <Grid item md={9} xs={12} className={classes.player}>
                    <VideoPlayer src={videoObj} sessionData={sessionData}/>
                </Grid>
                {sessionData && sessionData.chatUrl &&
                <Grid item md={3} xs={12}>
                    <iframe src= {sessionData.chatUrl} height="100%" width="100%" style={{border: 'none', maxHeight: '478px'}} title="Group Chat"></iframe>
                </Grid>
                }
            </Grid></Container>}
            <Container className={classes.playerDetails}>
                <PlayerInfo sessionData={sessionData} videoObj={videoObj}/>
            </Container>
            <Box className={classes.watchDetailWrapper}>
                <Container>
                    <SessionDetail sessionData={sessionData}/>
                </Container>
            </Box>
            <SpringModal/>
            {/* <Arena /> */}
        </div>
    )
}

export default Watch;